import * as dateMath from 'date-arithmetic';
import { stringUtil } from '../amorg-common';

export function getMonthStart(dt:Date)
{
    return new Date(dt.getFullYear(), dt.getMonth(), 1);
}


export function toDateTimestamp(dt:Date){
    const date = stringUtil.zeroPad(dt.getDate(), 2);
    const month = stringUtil.zeroPad(dt.getMonth()+1, 2);
    const year = dt.getFullYear();
    const hours = stringUtil.zeroPad(dt.getHours(), 2);
    const minutes = stringUtil.zeroPad(dt.getMinutes(), 2);
    const seconds = stringUtil.zeroPad(dt.getSeconds(), 2);
    const milliseconds = stringUtil.zeroPad(dt.getMilliseconds(), 3);
    return `${year}${month}${date}${hours}${minutes}${seconds}${milliseconds}`;
}

export function toDateString(dt:Date){
    const date = stringUtil.zeroPad(dt.getDate(), 2);
    const month = stringUtil.zeroPad(dt.getMonth()+1, 2);
    const year = dt.getFullYear();
    return `${date}-${month}-${year}`;
}

export function toDateNoYearString(dt:Date){
    const date = stringUtil.zeroPad(dt.getDate(), 2);
    const month = stringUtil.zeroPad(dt.getMonth()+1, 2);
    return `${date}-${month}`;
}

export function toTextDateString(dt:Date)
{
    return `${dt.getDate()}. ${toMonthText(dt)} ${dt.getFullYear()}`;
}

export function toMonthText(dt:Date)
{
    switch(dt.getMonth()){
        case 0: return 'januar';
        case 1: return 'februar';
        case 2: return 'marts';
        case 3: return 'april';
        case 4: return 'maj';
        case 5: return 'juni';
        case 6: return 'juli';
        case 7: return 'august';
        case 8: return 'september';
        case 9: return 'oktober';
        case 10: return 'november';
        case 11: return 'december';
        default: return 'N/A';
    }
}

export function toShortMonthText(dt:Date)
{
    switch(dt.getMonth()){
        case 0: return 'jan';
        case 1: return 'feb';
        case 2: return 'mar';
        case 3: return 'apr';
        case 4: return 'maj';
        case 5: return 'jun';
        case 6: return 'jul';
        case 7: return 'aug';
        case 8: return 'sep';
        case 9: return 'okt';
        case 10: return 'nov';
        case 11: return 'dec';
        default: return 'N/A';
    }
}

// export type DiffTypes = 
// { type:'past' } |
// { type:'hours', hours:number } |
// { type:'days', days:number } |
// { type:'weeks', weeks:number}
// export function timeToX(dateX:Date, now?:Date):DiffTypes
// {

//     const realNow = now || new Date();
//     const diff = dateX.getTime() - realNow.getTime();
    
//     if(diff < 0) 
//         return { type:'past'};
    
//     if(diff < 1000*60*60*24)
//         return { type:'hours', hours:Math.floor(diff/1000/60/60)};
    
//     if(diff < 1000*60*60*24*7)
//         return { type:'days', days:Math.floor(diff/1000/60/60/24)};

//     return { type:'weeks', weeks:Math.floor(diff/1000/60/60/24/7)};
// 
export function timeToXString(dateX:Date, now:Date):string
{
    const _1minute = 1000*60;
    const _1hour = 1000*60*60;
    const _1day = 1000*60*60*24;
    const _1week = 1000*60*60*24*7;

    const diff = Math.abs(dateX.getTime() - now.getTime());
    if(diff < _1minute)
        return "nu";
    if(diff < _1hour)
        return `${Math.floor(diff/_1minute)} minutter`;
    if(diff < _1day)
        return `${Math.floor(diff/_1hour)} timer`;
    if(diff < _1week)
        return `${Math.floor(diff/_1day)} dage`;
    return `${Math.floor(diff/_1week)} uger`;
}
export function timeToOpen(dateX:Date, now?:Date):string
{
    if(!now) now = new Date();
    if(now > dateX) 
        return 'Er åbnet';
    
    return `Åbner om ${timeToXString(dateX, now)}`;
}
export function timeToClose(dateX:Date, now?:Date):string
{
    if(!now) now = new Date();
    if(now > dateX) 
        return 'Er lukket';
    
    return `Lukker om ${timeToXString(dateX, now)}`;
}
export function toTimeString(dt:Date){
    const hours = dt.getHours();
    const mins = dt.getMinutes();
    return `${hours > 9 ? hours : '0'+hours}:${mins > 9 ? mins : '0'+mins}`;
}

export function toDateTimeString(dt:Date){
    return `${toDateString(dt)} ${toTimeString(dt)}`;
}

export function toDateTimeSpanString(dt1:Date, dt2:Date){
    return `${toDateString(dt1)} ${toTimeString(dt1)}-${toTimeString(dt2)}`;
}

export const DateFormat:(dateThis:Date, text:string) => string = function (
    dateThis:Date,
    text:string
):string{

    let result = "";
    let date = "";
    let time = "";

    const minuteInc = text.includes("min");

    const hourInc = text.includes("hh");

    const dateInc = text.includes("dd");

    const monthInc = text.includes("mm");

    const monthIncT = text.includes("MM");
    
    const yearInc = text.includes("yyyy");



    if(hourInc){
        const hourNum = new Date(dateThis).getHours()
        let hourStr = hourNum.toString();
        if(hourStr.length == 1){
            hourStr = "0"+hourStr;
        }
        
        time = time + hourStr;
    }


    if(minuteInc){
        const minuteNum = new Date(dateThis).getMinutes()
        let minuteStr = minuteNum.toString();
        if(minuteStr.length == 1){
            minuteStr = "0"+minuteStr;
        }
        
        time = time + ':' +  minuteStr;
    }



    if(dateInc){
        const dateNum = new Date(dateThis).getDate()
        let dateStr = dateNum.toString();
        if(dateStr.length == 1){
            dateStr = "0"+dateStr;
        }
        
        date = date + dateStr;
    }

    if(monthInc){
        let monthNum = new Date(dateThis).getMonth();
        monthNum = monthNum+1;
        let monthStr = monthNum.toString();
        if(monthStr.length == 1){
            monthStr = "0"+monthStr;
        }
        
        date = date + '.' + monthStr;
    }

    if(monthIncT){
        const monthNum = new Date(dateThis).getMonth();
        text = MonthString(monthNum);
        
        date = date + "." + text;
    }

    if(yearInc){
        const yearNum = new Date(dateThis).getFullYear()
        const yearStr = yearNum.toString()
       
        date = date + '.' + yearStr;
    }

    
    result = date + ' ' + time;

    return result;
    
}

export function MonthString(monthIndex:number)
{
    switch(monthIndex) {
        case 0: return "Jan";
        case 1: return "Feb";
        case 2: return "Mar";
        case 3: return "Apr";
        case 4: return "Maj";
        case 5: return "Jun";
        case 6: return "Juli";
        case 7: return "Aug";
        case 8: return "Sep";
        case 9: return "Okt";
        case 10: return "Nov";
        case 11: return "Dec";
        default: return "N/A";
    }
}

export function DateFormatSingle(dt:Date, text:string){

    const monthIncT = text.includes("MM");
    const year2 = text.includes("YY");
    const year4 = text.includes("yyyy");

    if(monthIncT){
        const monthNum = new Date(dt).getMonth();
        const monthString = MonthString(monthNum);
        
        return monthString;
    }


    if(year2){
        const yearNum = new Date(dt).getFullYear();
        const yearStr = yearNum.toString().substr(-2);
        return yearStr;
    }

    if(year4){
        const yearNum = new Date(dt).getFullYear();
        const yearStr = yearNum.toString();
        return yearStr;
    }

    
}


export const getFromTo = ():{from:Date, to:Date} => {
    return {
        from: dateMath.add(new Date(), -3, 'month'),
        to: dateMath.add(new Date(), 12, 'month')
    };
}

export const getNewStartTime = ():Date => {
    let now = new Date();
    now = dateMath.add(now, 1, 'day');
    now = dateMath.add(now, 1, 'hours');
    now.setMinutes(0, 0, 0);
    return now;
}

export function timeElapsedString(date:Date):string
{
    let timeStamp =  toDateTimeString(date);

    const days = dateMath.diff(date, new Date(), 'day');
    if(days < 14) {
        timeStamp = days === 1 ? '1 dag siden' : `${days} dage siden`;
    }

    const hours = dateMath.diff(date, new Date(), 'hours');
    if(hours < 24) {
        timeStamp = hours === 1 ? '1 time siden' : `${hours} timer siden`;
    }

    const minutes = dateMath.diff(date, new Date(), 'minutes');
    if(minutes < 60) {
        timeStamp = minutes === 1 ? '1 minut siden' : `${minutes} minutter siden`;
    }

    if(minutes < 1) {
        timeStamp = `lige nu`;
    }

    return timeStamp;
}